import React from 'react'
import { Typography, Grid } from '@material-ui/core';
import Aceptado from '../../assets/icono-aprobado.png';
import './styles.css'
import { useSelector } from 'react-redux';

export const EstadoAceptado = () => {

    const {afiliadoEncontrado} = useSelector(state => state.preinscripto)

    return (
    <Grid container style={{background:'white',height: '100vh'}} justify="center">

        <Grid container justify="center" alignItems="center" direction="column" className="estadoContainer estado-apto">
            <Typography variant="h5">Estado de Preafiliado: <b>Enviado</b></Typography>
            <img src={Aceptado} alt="icono de estado de circulación" className="iconoEstado" />
        </Grid>
        <Grid container justify="center">
        <Typography variant="h1"  gutterBottom className="alignmentCenter mainHeadline capitalize">Hola {afiliadoEncontrado.apellido_y_nombre.toLowerCase()}</Typography>
        </Grid>
        <Grid className="globalContainer">
            <Typography variant="h5" component="h2" className="alignmentCenter secondHeadline">Formulario enviado, actualizá tu estado confirmando tu mail. Entre todos nos cuidamos</Typography>

        <Grid container justify="center" alignItems="center">    
                <Grid container direction="row" justify="center" alignItems="center" className="contenedorMedio timerData">
                        <Typography variant="h5" component="p" color="secondary">Se envio Solicitud</Typography>
                </Grid>
            
        </Grid>
        </Grid>
    </Grid>
    )
}


